export function fromBase64(str) {
    return typeof window !== 'undefined'
        ? atob(str)
        : Buffer.from(str, 'base64').toString('ascii');
}
